import {
  colors,
  radius,
  spacing,
  stroke,
  textStyles,
  toCSS
} from "design-system/foundation";
import styled from "styled-components";
import Image from "next/image";
import { breakpoints } from "styles";

export const HistoryModalContent = styled.div`
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: ${spacing["5xl"]};
`;

export const HistoryLoadingContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 160px;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing["2xl"]};
  padding: ${spacing.none} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const EmptyImage = styled(Image)`
  width: 256px;
  height: 256px;
`;

export const EmptyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
`;

export const EmptyTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h5)};
  color: ${colors.text.base.primary};
  text-align: center;
`;

export const EmptyDesc = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body4Regular)};
  color: ${colors.text.base.secondary};
  text-align: center;
`;

export const EmptyButtonGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${spacing.xl};
  padding: ${spacing["2xl"]};
  border-top: ${stroke.xs} solid ${colors.border.state.default};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
    border-top: none;

    > button:nth-child(2) {
      display: none;
    }
  }
`;

export const HistoryListContainer = styled.div`
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: ${spacing.xl};
  overflow-y: auto;
  padding: ${spacing.none} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const HistoryList = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing["2xl"]};
  width: 100%;
  padding: ${spacing["2xl"]};
  border: ${stroke.md} solid ${colors.border.state.default};
  border-radius: ${radius.sm};
  background-color: ${colors.bg.base.default};
  cursor: pointer;
  text-align: left;

  .icon {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: ${colors.icon.semantic.brand};
  }
`;

export const ListPeriod = styled.p`
  margin: ${spacing.none};
  display: flex;
  flex: 1;
  ${toCSS(textStyles.caption.caption6)};
  color: ${colors.text.base.primary};
`;

export const HistoryButtonGroup = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  padding: ${spacing["2xl"]};
  border-top: ${stroke.xs} solid ${colors.border.state.default};
  background-color: ${colors.bg.base.default};

  @media ${breakpoints.tablet} {
    display: none;
  }
`;
